import ContactsApi from '@/api/Contacts/api'
import UsersApi from '@/api/Users/api'
import {get, concat, compact, startCase} from 'lodash'

export default {
  computed: {
    userListMail: {
      get () {
        return this.$store.getters.userListMail
      },
      set (data) {
        this.$store.dispatch('setUserListMail', data)
      }
    }
  },
  methods: {
    async getContactsListFromCRM (target) {
      const contactsResp = await ContactsApi.getContactsList({})
      const usersResp = await UsersApi.getUsersList({})
      this.userListMail = get(usersResp, 'data.users', [])
      const usersEmails = this.userListMail.map(item => {
        return item.email ? { email: item.email, name: startCase(item.username) } : ''
      })
      const contactsEmails = get(contactsResp, 'data.clients', []).map(item => {
        const email = get(item, ['email', 0], '')
        return email ? { email: email, name: startCase(item.nickName) } : ''
      })
      const allUsers = concat(compact(usersEmails), compact(contactsEmails))
      this.contactsList = concat(target, allUsers)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getContactsListFromCRM.js